import { useEffect, useRef, useState } from 'react'


export default function useAttendancePauseState(attendanceToday, attendanceId) {
    const apiPaused = !!attendanceToday?.is_paused
    const lastAttendanceIdRef = useRef(null)

    const [isPaused, setIsPaused] = useState(apiPaused)

    // When attendanceId changes (new day/new record), hard reset from API
    useEffect(() => {
        if (!attendanceId) {
            setIsPaused(false)
            lastAttendanceIdRef.current = null
            return
        }

        if (lastAttendanceIdRef.current !== attendanceId) {
            lastAttendanceIdRef.current = attendanceId
            setIsPaused(apiPaused)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attendanceId])

    // When API pause flag changes (after refetch), sync it
    useEffect(() => {
        // only sync if we have a valid record
        if (!attendanceId) return
        setIsPaused(apiPaused)
    }, [attendanceId, apiPaused])

    return [isPaused, setIsPaused]
}
